/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, {useState} from 'react';
import sass from "./index.module.sass";
import cn from "classnames";
import {IData} from "./TS/OperatingSystem";
import { ReactComponent as RemoveRow } from "images/TrashCan.svg";
import { ReactComponent as TabCloseIcon } from "images/TickIcon.svg";

export const CommonHeader = () => {
  return (
    <div className={sass.first}>
      <table className={sass.tableTTH} cellSpacing="0">
        <thead>
        <tr>
          <th>№</th>
          <th>Наименование и тип технического средства (маркировка)</th>
          <th>Заводской номер</th>
          <th>Сведения о сертификате</th>
          <th>Объект воздействия</th>
        </tr>
        </thead>
      </table>
    </div>  );
};

export const CommonRow:React.FC<{ collapse?:boolean,data:IData[]|{type:string,rows:IData[]}[],select:(row:IData)=>void,remove:(event:React.MouseEvent<HTMLOrSVGElement>,row:IData)=>void }>  = ({data:d,collapse,select,remove}) => {

  return <section data-comment-false={true} className={cn(sass.page__item, sass.page__item_active)}>
    <div className={sass.table}>
    {collapse ? d.map((data,index) => {
      return ('type' in data  &&  data.rows.length)?
        <Collapse key={index} remove={remove} type={data.type} rows={data.rows} select={select}/>
      :null
    }):
      !Array.isArray(d) ? null : (
        <table className={sass.tableTTH}>
          <tbody>
          {(d as IData[]).map((row, index) => (
            <tr key={row.id} onClick={() => select(row)}>
              <td>{index + 1}</td>
              <td>{row.name || "—"}</td>
              <td>{row.factoryNumber || "—"}</td>
              <td>{row.certificate || "—"}</td>
              <td>
                {row.objectInfluence || "—"}
                <RemoveRow
                  onClick={(e) => remove(e, row)}
                  width={18}
                  height={18}
                />
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      )
    }

    </div>
  </section>;

};


const Collapse:React.FC<{type:string,rows:IData[],select:(row:IData)=>void,remove:(event:React.MouseEvent<HTMLOrSVGElement>,row:IData)=>void}> = (data) => {
  const [active, setActive] = useState(true);

  return (
    <div className={cn(sass.colspan, sass[`colspan_${active}`])}>
      <div className={sass.subtable} onClick={() => setActive((prevState) => !prevState)}>
        {data.type}
        {/*<Tooltip menu={<div className={sass.tooltip}>{name}</div>}>*/}
        {/*  <span className={sass.hideText}>{name}</span>*/}
        {/*</Tooltip>*/}
        <TabCloseIcon width={9.6}/>
      </div>
      {!!data.rows.length && (
        <table className={sass.tableTTH}>
          <tbody>
          {data.rows.map((row: any, index: number) => (
            <tr key={row.id} onClick={() => data.select(row)}>
              <td>{index + 1}</td>
              <td>{row.name || "—"}</td>
              <td>{row.factoryNumber || "—"}</td>
              <td>{row.certificate || "—"}</td>
              <td>
                {row.objectInfluence || "—"}
                <RemoveRow
                  onClick={(e) => data.remove(e, row)}
                  width={18}
                  height={18}
                />
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      )}
    </div>
  )
};
